import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Handles HTTP errors with detailed error information.
 * 
 * @param {HttpErrorResponse} error - The HTTP error response.
 * @returns {Observable<never>} An observable that throws an error with detailed message.
 */
export function handleErrorFunction(error: HttpErrorResponse) {
    let errorMessage: string;
    let errorDetails: any = null;

    if (error.status === 0) {
        // Client-side or network error
        console.error('Client-side error occurred:', error.error);
        errorMessage = 'Unable to connect to the server. Please check your network connection.';
        errorDetails = error.error;
    } else {
        // Backend returned an unsuccessful response code
        console.error(
            `Backend returned code ${error.status}, body was:`,
            error.error
        );

        // Try to extract a meaningful message from the error response
        if (error.error?.message) {
            errorMessage = `Server error: ${error.error.message}`;
        } else if (error.error?.error) {
            errorMessage = `Server error: ${error.error.error}`;
        } else if (typeof error.error === 'string') {
            errorMessage = `Server error: ${error.error}`;
        } else {
            errorMessage = `Server error (${error.status}): ${error.statusText || 'Unknown error'}`;
        }

        errorDetails = {
            status: error.status,
            statusText: error.statusText,
            url: error.url,
            body: error.error
        };
    }

    // Log full details for debugging
    console.error('Full error details:', errorDetails);

    // Return error with detailed message
    return throwError(() => ({
        message: errorMessage,
        details: errorDetails,
        originalError: error
    }));
}